import {
    getComponentState
} from 'app/react/state/helpers';
import {
    mergeComponentState,
    setComponentStateValue,
    mergeComponentStateValue,
    deleteComponentStateValue,
    showSuccessPopup,
    showErrorPopup
} from 'app/react/state/actions/_index';
import {
    reformatISOString
} from 'app/react/helpers/_index';
import * as Booking from 'app/react/entities/events/bookings/index';
import * as BookingAttendees from 'app/react/entities/events/bookings/attendees/index';
import * as Pickup from 'app/react/entities/events/bookings/pickups';
import * as EventLocations from 'app/react/entities/events/locations/index';

export const UPDATE_MODAL_ID = 'updatePickupModal';

const FAILED_POPUP = (departureName, arrivalName) =>
    `Failed to update pickup from <strong>${departureName}</strong> to <strong>${arrivalName}</strong>.`;
const SUCCESSFUL_POPUP = (departureName, arrivalName) =>
    `Pickup from <strong>${departureName}</strong> to <strong>${arrivalName}</strong> successfully updated.`;

const getState = (state) =>
    getComponentState(state, UPDATE_MODAL_ID) || {};

const isOpen = (state) =>
    getComponentState(state, UPDATE_MODAL_ID).isOpened;

const mergeState = (newState) =>
    mergeComponentState(UPDATE_MODAL_ID, newState);

const setStateValue = (key, value) =>
    setComponentStateValue(UPDATE_MODAL_ID, key, value);

const mergeStateValue = (key, newState) =>
    mergeComponentStateValue(UPDATE_MODAL_ID, key, newState);

const deleteStateValue = (key) =>
    deleteComponentStateValue(UPDATE_MODAL_ID, key);

const close = () => (dispatch) => {
    dispatch(Booking.actions.unsetCurrentId());
    dispatch(Pickup.actions.unsetCurrentId());
    dispatch(mergeState({
        isOpened: false,
        isSaving: false,
        values: {},
        errors: {}
    }));
};

const open = (pickupId) => (dispatch, getState) => {
    const state = getState();
    const pickup = Pickup.stateHelpers.getOne(state, pickupId);
    const { booking, departureLocation, arrivalLocation } = pickup;
    const bookingId = booking;
    dispatch(Booking.actions.setCurrentId(bookingId));
    dispatch(Pickup.actions.setCurrentId(pickupId));
    dispatch(mergeState({
        isOpened: true,
        isLoading: true,
        pickupId,
        bookingId,
        values: pickup,
        isSettingCustomDepartureName: typeof departureLocation === 'undefined',
        isSettingCustomArrivalName : typeof arrivalLocation === 'undefined'
    }));
    dispatch(BookingAttendees.thunks.fetchAllForCurrentContext()).then(() => {
        dispatch(mergeState({ isLoading: false }));
    });
};

// We also check for driver === 0 for scheduler. (unassigned driver row is resourceId: 0)
const toAPIValues = values => ({
    ...values,
    driver: typeof values.driver === 'undefined' || values.driver === 0 ? null : values.driver,
    vehicle: typeof values.vehicle === 'undefined' ? null : values.vehicle,
    departure: reformatISOString(values.departure),
    arrival: reformatISOString(values.arrival),
    duration: typeof values.duration !== 'undefined' ? values.duration * 60 : undefined
});

const save = (values, onSaveSuccess) => (dispatch, getState) => {
    const state = getState();
    const { departureLocation, arrivalLocation } = values;
    let departureName = values.departureLocationName;
    let arrivalName = values.arrivalLocationName;
    const isSettingCustomDepartureName = typeof departureLocation === 'undefined';
    const isSettingCustomArrivalName = typeof arrivalLocation === 'undefined';
    if (!isSettingCustomDepartureName) {
        departureName = EventLocations.stateHelpers.getOne(state, departureLocation).name
    }
    if (!isSettingCustomArrivalName) {
        arrivalName = EventLocations.stateHelpers.getOne(state, arrivalLocation).name
    }
    dispatch(setStateValue('isSaving', true));
    const apiValues = toAPIValues(values);
    dispatch(Pickup.thunks.updateCurrent(apiValues, ['passengers', 'vehicle']))
        .then(({ isFailure, errors, response }) => {
            if (isFailure) {
                dispatch(showErrorPopup(FAILED_POPUP(departureName, arrivalName)));
                dispatch(mergeState({
                    errors,
                    isSaving: false
                }));
            } else {
                if (typeof onSaveSuccess === 'function') {
                    onSaveSuccess(response.result);
                }
                dispatch(showSuccessPopup(SUCCESSFUL_POPUP(departureName, arrivalName)));
                dispatch(close())
            }
        });
};

export const stateHelpers = {
    getState,
    isOpen
};

export const actions = {
    mergeState,
    setStateValue,
    mergeStateValue,
    deleteStateValue,
};

export const thunks = {
    open,
    close,
    save
};


